export const MAKE_REQUEST='USER_MAKE_REQUEST'
export const FAIL_REQUEST='FAIL_REQUEST'
export const FETCH_SINGLE_USER='FETCH_SINGLE_USER'
export const SET_EMPLOYEE_LIST='SET_EMPLOYEE_LIST'
export const SET_DUPLICATE_USER_STATUS='SET_DUPLICATE_USER_STATUS'
export const SET_EMPLOYEE_AS_UNIT_LIST='SET_EMPLOYEE_AS_UNIT_LIST'
export const CONTACT_US_LIST =
    "CONTACT_US_LIST";
export const SET_CANCEL_ACTION_RESPONSE = 'SET_CANCEL_ACTION_RESPONSE';
export const SET_CLOSE_ACTION_RESPONSE = 'SET_CLOSE_ACTION_RESPONSE';
export const SET_REJECT_ACTION_RESPONSE = 'SET_REJECT_ACTION_RESPONSE';
export const SET_FORWARD_ACTION_RESPONSE = 'SET_FORWARD_ACTION_RESPONSE';
export const SET_VIEW_LEAD_RESPONSE = 'SET_VIEW_LEAD_RESPONSE';
export const EMAIL_LOGS_LIST ='EMAIL_LOGS_LIST'